import { Toaster as Sonner } from "sonner";
//import "./toast.css";
import "./customtoast.css";

type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => {
  return (
    <Sonner
      className="toaster"
      expand={true}
      richColors={false}
      closeButton={false}
      toastOptions={{
        duration: 4000,
        classNames: {
          toast: "toast",
          title: "toast-title",
          description: "toast-description",
          actionButton: "toast-action-button",
          cancelButton: "toast-cancel-button",
          closeButton: "toast-close-button",
        },
      }}
      {...props}
    />
  );
};

export { Toaster };
